import {
  AppLayout,
  AppLayoutContent,
  Navbar,
  NavbarTopContent,
  NavbarMiddleContent,
  NavbarBottomContent,
  NavbarButton,
  Stack,
  Avatar,
  NavbarLogo,
  Divider,
} from "@digitalreality/ui";
import {
  MenuAltIcon,
  ReceiptIcon,
  FolderIcon,
  LogoutIcon,
} from "@digitalreality/ui-icons";
import LanguageSwitch from "./Components/LanguageSwitch/LanguageSwitch";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./App.css";
import { logout } from "./Services/AuthService";
import { useAppState } from "./StateStore/Store";
import { getUserDetails } from "./StateStore/UserAuth/UserAuthActionMiddleware";
import { loggedOut } from "./StateStore/UserAuth/UserAuthActions";

import i18n from "./i18n";
import "dayjs/locale/de";
import "dayjs/locale/cs";
import "dayjs/locale/fr";

const logo = require("./Images/appicon.png");

function App() {
  const navigate = useNavigate();

  const { state, dispatch } = useAppState();

  useEffect(() => {
    getUserDetails()(dispatch);
  }, []);

  useEffect(() => {
    if (!state.userAuth.authorized && !sessionStorage.getItem("authorized")) {
      navigate("/login");
    }
  }, [state.userAuth.authorized]);

  const handleLogout = () => {
    logout().then((response) => {
      if (response.success) {
        dispatch(loggedOut());
        navigate("/login");
      }
    });
  };

  const setUserAvatar = () => {
    return state.userAuth.user?.firstname.charAt(0);
  };

  const userName = `${state.userAuth.user?.firstname} ${state.userAuth.user?.lastname}`;

  return (
    <AppLayout>
      <Navbar className="navbar">
        <NavbarLogo>
          <NavbarButton title="" disabled className="navbarLogo">
            <Avatar src={logo} />
          </NavbarButton>
        </NavbarLogo>
        <NavbarTopContent>
          <Link to="/projects">
            <NavbarButton tall title="Home" className="navBarButton">
              <MenuAltIcon />
            </NavbarButton>
          </Link>
        </NavbarTopContent>
        <Divider variant="middle" />
        <NavbarMiddleContent>
          <Stack gap={2}>
            <Link to="/projects">
              <NavbarButton title="Projects" className="navBarButton">
                <FolderIcon />
              </NavbarButton>
            </Link>

            {/* Commented out until Licenses page is empty
            <Link to="licenses">
              <NavbarButton
                onClick={() => console.log("selected")}
                title="Licenses"
                className="navBarButton"
              >
                <ReceiptIcon />
              </NavbarButton>
            </Link> */}
          </Stack>
        </NavbarMiddleContent>
        <NavbarBottomContent>
          <NavbarButton title="" className="navBarButton">
            <LanguageSwitch hideCarret={true} />
          </NavbarButton>
          <NavbarButton title={userName} className="navBarButton">
            <Avatar alt={userName}>{setUserAvatar()}</Avatar>
          </NavbarButton>
          <NavbarButton
            tall
            title="Logout"
            className="navBarButton"
            onClick={handleLogout}
          >
            <LogoutIcon />
          </NavbarButton>
        </NavbarBottomContent>
      </Navbar>
      <AppLayoutContent>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={i18n.language}
        >
          <Outlet />
        </LocalizationProvider>
      </AppLayoutContent>
    </AppLayout>
  );
}

export default App;
